/**
 * App root -- routing + AuthProvider.
 */
import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Layout } from "./components/layout/Layout";
import { AuthProvider } from "./contexts/AuthContext";
import { LogoProvider } from "./contexts/LogoContext";
import { PublicSettingsProvider } from "./contexts/PublicSettingsContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Marketplace from "./pages/Marketplace/Marketplace";
import ForumList from "./pages/Forums/ForumList";
import ThreadDetail from "./pages/Forums/ThreadDetail";
import NewThread from "./pages/Forums/NewThread";
import CategoryThreads from "./pages/Forums/CategoryThreads";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import Search from "./pages/Search";
import ProductDetail from "./pages/Product/ProductDetail";
import CheckoutSuccess from "./pages/Checkout/CheckoutSuccess";
import CheckoutCancel from "./pages/Checkout/CheckoutCancel";
import BillingSuccess from "./pages/Checkout/BillingSuccess";
import Sell from "./pages/Sell/Sell";
import Profile from "./pages/Profile/Profile";
import DealerStorefront from "./pages/Dealer/DealerStorefront";
import { About, Contact, FAQ, Privacy, Terms } from "./pages/Legal/Legal";
import ComingSoon from "./pages/ComingSoon";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <PublicSettingsProvider>
      <LogoProvider>
        <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            {/* Public */}
            <Route path="/" element={<Marketplace />} />
            <Route path="/search" element={<Search />} />
            <Route path="/forums" element={<ForumList />} />
            <Route path="/forums/c/:slug" element={<CategoryThreads />} />
            <Route path="/forums/thread/:id" element={<ThreadDetail />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/billing/success" element={<BillingSuccess />} />
            <Route path="/billing/cancel" element={<CheckoutCancel />} />

            {/* Legal / info */}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            {/* Protected */}
            <Route
              path="/sell"
              element={
                <ProtectedRoute>
                  <Sell />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dealer/:id"
              element={<DealerStorefront />}
            />
            <Route
              path="/forums/new"
              element={
                <ProtectedRoute>
                  <NewThread />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
        </AuthProvider>
      </LogoProvider>
    </PublicSettingsProvider>
  );
}

export default App;
